import { render } from "./WordDetailPage.vue?vue&type=template&id=4b72f97a&ts=true"
import script from "./WordDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./WordDetailPage.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/word/WordDetailPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b72f97a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b72f97a', __exports__)) {
    api.reload('4b72f97a', __exports__)
  }
  
  module.hot.accept("./WordDetailPage.vue?vue&type=template&id=4b72f97a&ts=true", () => {
    api.rerender('4b72f97a', render)
  })

}


export default __exports__